import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from 'app/_services';

@Component({
  standalone: false, changeDetection: ChangeDetectionStrategy.Eager,
 template: '' })
export abstract class RestrictionsComponent {
  authenticationService = inject(AuthenticationService);

  get isReadonly(): boolean {
    return this.authenticationService.isReadonly;
  }
}
